import {ChangeDetectionStrategy, Component, inject} from '@angular/core';
import {Router} from '@angular/router';
import {select, Store} from '@ngrx/store';
import {Observable, take} from 'rxjs';
import {selectRouterParam} from 'src/app/core/store/router/router.selector';
import {CurrentSkedTaskDetailComponent} from 'src/app/current-sked/task-detail/current-sked-task-detail.component';

@Component({
  selector: 'project-view-task-detail',
  standalone: true,
  imports: [CurrentSkedTaskDetailComponent],
  templateUrl: './project-view-task-detail.component.html',
  styleUrl: './project-view-task-detail.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProjectViewTaskDetailComponent {
  private router = inject(Router);
  private store$ = inject(Store);
  projectId$: Observable<string> = this.store$.pipe(select(selectRouterParam('projectId')));

  onBack() {
    this.projectId$.pipe(take(1)).subscribe(projectId => {
      if (projectId) {
        this.router.navigate(['projects', projectId]);
      } else {
        this.router.navigate(['projects']);
      }
    });
  }

  onGet() {
    // Handle any refresh/get events from the task detail component
    // This can be used if we need to refresh project data after task updates
  }
}
